import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail, Phone, MapPin, Globe, MessageCircle, Instagram, Facebook } from 'lucide-react';

const CONTACTS = [
  { icon: Phone, label: 'Teléfono', value: '+1 (809) 555-0123', color: '#10B981', bg: 'from-emerald-50 to-green-50' },
  { icon: Mail, label: 'Correo Electrónico', value: 'info@nutriquimia.com', color: '#3B82F6', bg: 'from-blue-50 to-indigo-50' },
  { icon: MessageCircle, label: 'WhatsApp', value: '+1 (809) 555-0123', color: '#22C55E', bg: 'from-green-50 to-emerald-50' },
  { icon: Globe, label: 'Sitio Web', value: 'www.nutriquimia.com', color: '#8B5CF6', bg: 'from-violet-50 to-purple-50' },
  { icon: MapPin, label: 'Dirección', value: 'Santo Domingo, República Dominicana', color: '#EF4444', bg: 'from-red-50 to-rose-50' },
];

const SOCIAL = [
  { icon: Instagram, label: 'Instagram', value: '@nutriquimia', color: '#E4405F', bg: 'from-pink-50 to-rose-50' },
  { icon: Facebook, label: 'Facebook', value: 'Nutriquimia', color: '#1877F2', bg: 'from-blue-50 to-sky-50' },
];

const DistributorContactPage = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto space-y-5 animate-fade-in" data-testid="distributor-contact-page">
      {/* Header */}
      <div className="pt-1">
        <button
          onClick={() => navigate('/distributor/help')}
          className="flex items-center gap-1.5 text-sm text-amber-500 font-semibold mb-3 hover:gap-2.5 transition-all duration-200"
          data-testid="back-to-help"
        >
          <ArrowLeft size={16} /> Volver a Ayuda
        </button>
        <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
          Vías de Contacto
        </h1>
        <p className="text-sm text-gray-400 mt-1 font-medium">Nuestros canales de comunicación</p>
      </div>

      {/* Contact List */}
      <div className="space-y-3">
        {CONTACTS.map((contact, idx) => {
          const IconComponent = contact.icon;
          return (
            <div
              key={method.label || idx}
              className="bg-white rounded-2xl border border-gray-100/50 p-5 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 flex items-center gap-4"
              style={{ animationDelay: `${idx * 60}ms` }}
              data-testid={`contact-${contact.label.toLowerCase().replace(/\s/g, '-')}`}
            >
              <div className={`w-12 h-12 bg-gradient-to-br ${contact.bg} rounded-xl flex items-center justify-center flex-shrink-0`}>
                <IconComponent size={22} style={{ color: contact.color }} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider">{contact.label}</p>
                <p className="font-bold text-gray-900 text-sm mt-0.5 truncate">{contact.value}</p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Social Media */}
      <div>
        <h2 className="text-lg font-bold text-gray-900 mb-3" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
          Redes Sociales
        </h2>
        <div className="grid grid-cols-2 gap-3">
          {SOCIAL.map((social, idx) => {
            const IconComponent = social.icon;
            return (
              <div
                key={method.label || idx}
                className="bg-white rounded-2xl border border-gray-100/50 p-4 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 flex items-center gap-3"
                data-testid={`social-${social.label.toLowerCase()}`}
              >
                <div className={`w-10 h-10 bg-gradient-to-br ${social.bg} rounded-xl flex items-center justify-center flex-shrink-0`}>
                  <IconComponent size={20} style={{ color: social.color }} />
                </div>
                <div className="min-w-0">
                  <p className="text-xs text-gray-400 font-semibold">{social.label}</p>
                  <p className="font-bold text-gray-900 text-sm truncate">{social.value}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DistributorContactPage;
